<template>
  <div class="c-proposal-thanks">
    <div class="c-proposal-thanks__inner">
      <div class="c-proposal-thanks__image">
        <div class="c-image--radius">
          <img src="@/assets/img/img-chara-task.svg" alt="" width="76" />
        </div>
      </div>
      <div class="c-proposal-thanks__content">
        <h3 class="c-proposal-thanks__title">Thank you!</h3>
        <p>
          改善提案からのタスクを登録しました！<br />登録したタスクは「タスクリスト」から<br />確認できます。
        </p>
        <div>
          <Button
            v-if="hasNext"
            fsize="f12"
            variant="main"
            class="l-w-180"
            @click="next"
          >
            次の改善提案を見る
          </Button>
        </div>
        <div>
          <Button
            :to="{ name: 'taskList' }"
            fsize="f12"
            variant="light"
            class="l-w-180 l-mt-3"
          >
            タスクリストを確認する
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button';

export default {
  props: {
    proposals: {
      type: Array,
      required: true
    }
  },
  components: {
    Button
  },
  computed: {
    hasNext() {
      return this.proposals.length;
    }
  },
  methods: {
    next() {
      this.$emit('next');
    }
  }
};
</script>
